module.exports = __webpack_public_path__ + "img/46200.767e4b0d.jpg";